module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-defcd808a1ccf86f2fda82490b106fb4.png";